export const SPHERE_CONFIG = {
  // Sphere formation animation range (0..1 scroll progress)
  formStart: 0.35,
  completeAt: 0.6,
  
  // Raw scroll point where we reach completion (sphere formed)
  // Leaves 0.7 -> 1.0 as "extra scroll" to linger/rotate
  holdStartRaw: 0.6,
  
  // Text reveal animation range
  revealStart: 0.55,
  
  // Reset gate if user scrolls back up
  resetIfBelow: 0.2,
} as const

export const HERO_CONFIG = {
  // Hero phrase opacity fade-out
  fadeStart: 0.02,
  fadeEnd: 0.30,
  
  // Transition from solo image to columns layout
  soloToColumnsStart: 0.04,
  soloToColumnsEnd: 0.25,
} as const

export const SCROLL_CONFIG = {
  smoothLambda: 10,
  publishEpsilon: 0.0015,
} as const
